const Style = {

  base: 'block w-[6em] h-[2.5em] mx-auto outline-none md:w-[8em]'

}

export default Style;
